import questionnaireService from "./questionnaireService";

const questionnaireServices = [
    ...questionnaireService
]

export default questionnaireServices;